// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__QXi8a","row":"Node_row__2ddT2","label":"Node_label__2sTwh","footer":"Node_footer__S_l3u"};